<template>
  <div>
    <div class="main">
      <el-card class="box-card margin-b-20">
        <p class="encabezado"><strong>Captura los datos</strong> de contacto de tu cliente</p>
        <el-form
          ref="clientForm"
          :rules="rules"
          :model="model"
          @submit.native.prevent="onSubmit"
        >
          <el-form-item
            prop="clientName"
            label="Nombre del cliente"
          >
            <el-input
              ref="inputClient"
              v-model="model.clientName"
              placeholder="Nombre completo"
              class="i-user"/>
          </el-form-item>
          <el-form-item
            prop="clientPhone"
            label="Celular"
          >
            <el-input
              v-model="model.clientPhone"
              :maxlength="10"
              type="tel"
              placeholder="Celular con lada"
              class="i-phone"/>
          </el-form-item>
          <el-form-item
            prop="clientEmail"
            label="Correo electrónico"
          >
            <el-input
              v-model="model.clientEmail"
              type="email"
              placeholder="Correo electrónico"
              class="i-mail"/>
          </el-form-item>
          <el-form-item
            prop="carBrand"
            label="Marca del vehículo"
          >
            <el-input
              v-model="model.carBrand"
              placeholder="Escribe la marca"
              class="i-car"/>
          </el-form-item>
          <el-form-item
            prop="carModel"
            label="Modelo del vehículo"
          >
            <el-input
              v-model="model.carModel"
              placeholder="Escribe el modelo"
              class="i-car"/>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <router-link :to="{name:'codes'}">
                <el-button>Atrás</el-button>
              </router-link>
            </el-col>
            <el-col :span="12">
              <el-button
                :disabled="submitting"
                type="primary"
                native-type="submit">Siguiente
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import ClientModel from '@/models/client.model'

export default {
  name: 'ClientData',
  data () {
    return {
      submitting: false,
      model: ClientModel.model(),
      rules: ClientModel.rules()
    }
  },
  mounted () {
    this.$refs.inputClient.focus()
    this.model = Object.assign({}, this.$store.getters['app/order'])
  },
  methods: {
    onSubmit () {
      this.submitting = true
      this.$refs.clientForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('app/order', this.model).then(() => {
            this.$router.push({name: 'summary'})
          })
        } else {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/client-form.vue